import React, { Component } from "react";
import PropTypes from "prop-types";
import Radium from "radium";
import { connect } from "react-redux";
import { semanticColors } from "../../../Globals/styles";
import SuggestSelectInput from "../../../Common/suggestSelectInput";
import { Scrollbars } from "react-custom-scrollbars";
import Employee from "./employee";
import EmployeeDropableTrashcan from "../../../Common/employeeDropableTrashcan";
import EmployeeDropableSorter from "./employeeDropableSorter";
import {
  attemptGetEmployees,
  getEmployeeSuggestions,
  attemptAddEmployee,
  setEmployeeIsDragging,
  rmEmployeeFromDepartment,
  attemptMoveEmployee,
} from "./actions";

class EmployeeListView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      suggestionValue: { id: null, name: null },
    };
  }
  componentWillMount = () => {
    const { dispatch, params } = this.props;
    dispatch(attemptGetEmployees(params.departmentId));
  };
  onEmployeeSuggestChange = (val) => {
    const { dispatch, params } = this.props;
    if (val.id) {
      this.setState({
        suggestionValue: { name: null, id: null },
      });
      //add the employee to the list
      dispatch(attemptAddEmployee(val, params.departmentId));
    } else {
      this.setState({
        suggestionValue: val,
      });
    }
  };
  render() {
    const {
      toggleSidebar,
      dispatch,
      employeeSuggestions,
      employees,
      employeeIsDragging,
      params,
    } = this.props;
    let employeeNodes = employees.map((employee, index) => {
      return (
        <div
          key={employee.id + index}
          className="row"
          style={styles.employeeContainer}
        >
          <EmployeeDropableSorter
            index={index}
            isLast={false}
            moveEmployee={(newIndex) =>
              dispatch(
                attemptMoveEmployee(newIndex, index, params.departmentId)
              )
            }
          />
          <Employee
            employee={employee}
            index={index}
            setEmployeeIsDragging={(employeeId) =>
              dispatch(setEmployeeIsDragging(employeeId))
            }
            onRemove={() =>
              dispatch(rmEmployeeFromDepartment(index, params.departmentId))
            }
          />
          {index === employees.length - 1 ? (
            <EmployeeDropableSorter
              index={index}
              isLast={true}
              moveEmployee={(newIndex) =>
                dispatch(
                  attemptMoveEmployee(newIndex, index, params.departmentId)
                )
              }
            />
          ) : null}
        </div>
      );
    });

    return (
      <div style={styles.outerContainer}>
        <div style={styles.container}>
          <div style={styles.heading}>
            <h2 style={styles.headingText}>Tildel mandskab</h2>
          </div>
          <i
            className="fa fa-times waves-icon"
            aria-hidden="true"
            style={styles.toggleSidebarCross}
            onClick={toggleSidebar}
          />
          <div style={styles.addEmployeeContainer}>
            {employeeIsDragging ? (
              <EmployeeDropableTrashcan
                rmEmployeeFromProject={(employeeIndex) =>
                  dispatch(
                    rmEmployeeFromDepartment(employeeIndex, params.departmentId)
                  )
                }
              />
            ) : (
              <SuggestSelectInput
                onQuery={(val) => dispatch(getEmployeeSuggestions(val))}
                suggestions={
                  this.state.suggestionValue.name ? employeeSuggestions : []
                }
                placeholder="Tilføj nyt mandskab"
                onChange={this.onEmployeeSuggestChange}
                value={this.state.suggestionValue}
                inputStyle={styles.suggestInput}
              />
            )}
          </div>
          <Scrollbars
            style={{ width: "100%", height: "100%", textAlign: "center" }}
          >
            {employeeNodes.length > 0 ? (
              employeeNodes
            ) : (
              <img
                alt="billede"
                src="/images\emptyStates\Emptystate_Mandskab.png"
              />
            )}
          </Scrollbars>
        </div>
      </div>
    );
  }
}

var styles = {
  outerContainer: {
    height: "100%",
    width: "100%",
  },
  container: {
    padding: "104px 12px 0 12px",
    height: "100%",
    position: "relative",
  },
  heading: {
    position: "absolute",
    width: "100%",
    top: "17px",
    padding: "0 12px",
    left: "0",
  },
  headingText: {
    width: "100%",
    paddingBottom: "8px",
    borderBottom: "1px solid " + semanticColors.mainBackground,
  },
  toggleSidebarCross: {
    position: "absolute",
    fontSize: "20px",
    right: "5px",
    top: "5px",
    height: "40px",
    width: "40px",
    textAlign: "center",
    lineHeight: "40px",
    zIndex: "10",
  },
  addEmployeeContainer: {
    position: "absolute",
    top: "54px",
    left: "12px",
    right: "12px",
    height: "42px",
  },
  suggestInput: {
    height: "42px",
  },
  employeeContainer: {
    margin: "0",
    position: "relative",
  },
};

const selectProps = (state) => {
  return {
    ...state.employeeListViewReducer,
  };
};

EmployeeListView.propTypes = {
  dispatch: PropTypes.func.isRequired,
  toggleSidebar: PropTypes.func.isRequired,
  params: PropTypes.shape({
    departmentId: PropTypes.string.isRequired,
  }).isRequired,
  employeeSuggestions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
  employeeIsDragging: PropTypes.string,
};
export default connect(selectProps)(Radium(EmployeeListView));



// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Kanban/EmployeeListView/index.jsx